export default __webpack_public_path__ + "static/media/0ee2ef348636b46fe30400e14036b9bb.svg";